import React from 'react';
import { MealPlanAssignmentStatus } from '../../utils/mealPlan';

const initialValues = {
  isReady: false,
  isLoading: false,
  recipesCollection: { docs: [] },
  coachRecipesCollection: { docs: [] },
  publicRecipesCollection: { docs: [] },
  recipesDocs: [],
  selectedRecipe: null,
  mealPlanAssignments: null,
  automationTemplate: null,
  assignmentViewsCollection: { docs: [] },
  coachMealPlanViewsCollection: null,
  publicMealPlanViewsCollection: null,
  comnbinedMealPlanViews: [],
  mealPlansStatusCount: {
    [MealPlanAssignmentStatus.ACTIVE]: 0,
    [MealPlanAssignmentStatus.PENDING]: 0,
    [MealPlanAssignmentStatus.NEEDS_REFRESH]: 0,
    [MealPlanAssignmentStatus.MANUALLY_REFRESHABLE]: 0,
  },
  showArchivedMealPlans: false,
  showArchivedRecipes: false,
  mealPlanConfig: null,
  coachConfig: { archivedRecipes: [] },
  canonicalIngredients: null,
  isCanonicalIngredientsLoading: false,
  loadCanonicalIngredients: async () => {},
};

const MealPlanContext = React.createContext(initialValues);

export default MealPlanContext;
export {
  initialValues,
};
